<div class="login-container">
  <div class="text-holder">
    <p *ngIf="loading">Processing authentication...</p>

    <p *ngIf="error">Authentication failed. Please try again.</p>
    <button (click)="userService.loginWithBrowser()">Return to Login</button>
  </div>
</div>
